'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fontSizes", "value", "onChange"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import UITextToolbarInputDropdown from '../editor/UITextToolbarInputDropdown';
import withDisabledContext from '../hoc/withDisabledContext';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.formatting.FontSize.${suffix}`;
class FontSizeSelect extends Component {
  constructor(...args) {
    super(...args);
    this.handleInputSelect = inputValue => {
      const parsedInt = parseInt(inputValue, 10);
      if (!isNaN(parsedInt)) {
        this.props.onChange(`${parsedInt}px`, 'input');
      }
    };
  }
  render() {
    const _this$props = this.props,
      {
        fontSizes,
        value,
        onChange
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const rounded = Math.round(parseFloat(value, 10) * 10) / 10;
    return /*#__PURE__*/_jsx(UITextToolbarInputDropdown, Object.assign({}, rest, {
      options: fontSizes,
      value: isNaN(rounded) ? null : `${rounded}px`,
      placeholder: I18n.text(i18nKey('placeholder')),
      onOptionSelect: optionValue => onChange(optionValue, 'option'),
      onInputSelect: this.handleInputSelect
    }));
  }
}
FontSizeSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  fontSizes: PropTypes.array.isRequired
};
export default withDisabledContext(FontSizeSelect);